const LOAD_STATES = {
  initial: { loading: true, error: false, initial: true },
  started: { loading: true, error: false, initial: false },
  done: { loading: false, error: false, initial: false },
  failed: { loading: false, error: true, initial: false }
};

export { LOAD_STATES };
